import { render, staticRenderFns } from "./PigeanLocusZoom.vue?vue&type=template&id=4fac47ad&scoped=true&"
import script from "./PigeanLocusZoom.vue?vue&type=script&lang=js&"
export * from "./PigeanLocusZoom.vue?vue&type=script&lang=js&"
import style0 from "./PigeanLocusZoom.vue?vue&type=style&index=0&id=4fac47ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fac47ad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fac47ad')) {
      api.createRecord('4fac47ad', component.options)
    } else {
      api.reload('4fac47ad', component.options)
    }
    module.hot.accept("./PigeanLocusZoom.vue?vue&type=template&id=4fac47ad&scoped=true&", function () {
      api.rerender('4fac47ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PigeanLocusZoom.vue"
export default component.exports